'use strict';

// Handler to redirect to the new appointment page route
// We have hardcoded links to the old route in the API
angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.legacyRedirect', {
    url: 'appointments/:tab/:page/:appointmentId/?backTo',
    templateUrl: '/views/partials/clinic/appointment.html',
    controller: function($state) {
      const appointmentId = $state.params.appointmentId;
      $state.go('clinic.appointment', {
        tab: 'requests',
        page: 1,
        appointmentId,
        backTo: $state.params.backTo,
      }, {
        location: 'replace',
      });
    },
  });
});

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.appointment', {
    url: 'appointment/{appointmentId:int}/',
    params: {
      backTo: null,
    },
    templateUrl: '/views/partials/clinic/appointment.html',
    controller: 'ClinicAppointmentCtrl',
    resolve: {
      appointment: function(AppointmentService, $stateParams) {
        return AppointmentService.getAppointment($stateParams.appointmentId);
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicAppointmentCtrl', function(
  $scope,
  $state,
  appointment,
  ClinicConfig,
  OCDomUtil,
  OCChatWidgetUtil,
  $timeout,
  WebSocketsService,
  IframeService,
) {
  OCDomUtil.addOverlayBodyClass($scope, true, 'no-scroll');

  $scope.appointment = appointment;
  $scope.backTo = $state.params.backTo;

  // Load iframe with the appointment management page
  const appointmentUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/appointment/${appointment.id}`;

  $scope.clinicId = appointment.provider.clinic.id;
  $scope.clinicName = appointment.provider.clinic.name;
  $scope.providerId = appointment.provider.id;

  const iframeElement = angular.element('#js-appointment-iframe')[0];
  iframeElement.src = encodeURI(appointmentUrl);

  $scope.goBack = function() {
    if ($scope.backTo) {
      window.history.back();
    } else {
      $state.go('clinic.appointments');
    }
  };

  IframeService.setupFunctionCallHandler($scope);

  $scope.$on('$destroy', () => {
    // Safety net: always restore the widget when leaving this page.
    OCChatWidgetUtil.show();
    $scope.$emit('closeClinicV4');
  });

  $timeout(() => {
    WebSocketsService.subscribeToAppointmentSyncUpdates($scope.appointment.id, () => {
      IframeService.sendMessage({
        type: 'appointmentSyncUpdate',
        data: { appointmentId: $scope.appointment.id },
        iframe: iframeElement,
      });
    });
  });
});
